import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { get, omit } from 'lodash';

@Component({
  selector: 'app-section-header',
  templateUrl: './section-header.component.html',
})
export class FormlyFieldSectionHeaderComponent extends FieldType implements OnInit {
  collapsed = false;
  constructor() {
    super();
  }
  ngOnInit() {
    const templateOptions = get(this, 'field.templateOptions');
    if (templateOptions) {
      this.field.templateOptions = omit(templateOptions, 'label');
    }
  }
}
